import styled from '@emotion/styled';

export default styled.label`
	display: block;
	margin-bottom: 2em;

	${props => (props.radio ? '' : props.theme.formElement || '')}
`;
